import { createFileRoute } from "@tanstack/react-router";

import AdminUsersPage from "@/app/admin/users/AdminUsersPage";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsersPage,
});
